<template>
    <div class="main-content">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h5>Письма</h5>
                    </div>
                    <div class="card-body">
                        <EditLetter :id="id"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import api from '@/api'
    import EditLetter from '@/components/settings/letters/CreateEditLetter'

    export default {
        data () {
          return {
              id: null
          }
        },
        components: {
            EditLetter
        }
    }

</script>